// The longest group-class duration in DurationOptions, so a session already in
// progress still falls inside the fetch window.
export const APPOINTMENTS_LOOKBACK_MINUTES = 180;

export const RAIL_SECTION_ROW_CAP = 3;

export enum RailSectionErrorLabel {
  Appointments = 'upcoming appointments',
  Assessments = 'overdue assessments',
  IntakeBanner = 'the intake survey status',
  Messages = 'unread messages',
  Tasks = 'open tasks',
}
